import React, { FC, ReactNode } from "react";

import { MenuType } from "~/hooks";

import { Link } from "~/ui";

type PropsType = {
  menuType: MenuType;
  matchMenu: boolean;
  href?: string;
  selectMenu: (menuType: MenuType) => void;
  children: ReactNode;
};

export const SidebarMenuWrapper: FC<PropsType> = ({
  menuType,
  matchMenu,
  href,
  selectMenu,
  children,
}: PropsType) => {
  const className = `group flex items-center justify-center w-full py-3 cursor-pointer relative ${
    matchMenu
      ? "after:content-[''] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:w-0.5 after:h-6 after:bg-primary-600 after:rounded-l-full"
      : "hover:bg-secondary-100"
  }`;

  return href ? (
    <Link className={className} to={href} onClick={() => selectMenu(menuType)}>
      {children}
    </Link>
  ) : (
    <div className={className} onClick={() => selectMenu(menuType)}>
      {children}
    </div>
  );
};
